import React from "react";
import UserList from "../../Widgets/UserList";

import { Container } from "react-bootstrap";

import { useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";

import "./UsersPage.css";

const UsersPage = () => {
  // const onAddUser = () => {
  //   console.log('onAddUser event');
  //   window.location.href='/add-user';
  // };

  const currentUser = useSelector((state) => state.authentication.user);
  const isCurrentUserAdmin =
    currentUser && currentUser.is_admin && currentUser.is_admin === 1 ? 1 : 0;
  const isAccountPrimaryUser =
    currentUser &&
    currentUser.is_account_primary_user &&
    currentUser.is_account_primary_user === 1
      ? 1
      : 0;
  const currentUserAccountId = currentUser ? currentUser.account_id : "";

  return (
    <div className="users-page">
      <Container>
        {/* Page Title */}
        <h2>
          <FontAwesomeIcon className="page-title-icon" icon={faUsers} />
          <span className="page-title">Users</span>
        </h2>
        {/* End Page Title */}
        {/* Page Content */}
        <UserList
          userType="user"
          isCurrentUserAdmin={isCurrentUserAdmin}
          isAccountPrimaryUser={isAccountPrimaryUser}
          currentUserAccountId={currentUserAccountId}
        />
        {/* End Page Content */}
      </Container>
    </div>
  );
};

export default UsersPage;
